import { render, staticRenderFns } from "./OpenBusBtn.vue?vue&type=template&id=31dd48be&"
import script from "./OpenBusBtn.vue?vue&type=script&lang=js&"
export * from "./OpenBusBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports